import { render, staticRenderFns } from "./CustomMenusDraggableList.vue?vue&type=template&id=4eeed3fe&scoped=true&"
import script from "./CustomMenusDraggableList.vue?vue&type=script&lang=js&"
export * from "./CustomMenusDraggableList.vue?vue&type=script&lang=js&"
import style0 from "./CustomMenusDraggableList.vue?vue&type=style&index=0&id=4eeed3fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eeed3fe",
  null
  
)

export default component.exports